import { Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import ApiUtils from './../../utils/api_utils';
import * as PageRoutes from './../../utils/route_pages';

const PreviewResult = (props) => {
  const { onCancel, payload } = props;
  const { img, img2 } = payload;
  const navigate = useNavigate();
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    dotsClass: 'slick-dots center-dots',
  };

  const createDataImages = (imagesArray) => {
    return imagesArray.map((img) => ({
      images: {
        img: {
          display: img ? URL.createObjectURL(img) : null,
          file: img,
        },
      },
    }));
  };

  const dataImages = createDataImages([img, img2]).filter(
    (item) => item?.images?.img?.display !== null
  );

  const handleNext = () => {
    navigate(`${PageRoutes.snapReceipt}/detail`, {
      state: { payload: dataImages },
    });
  };

  return (
    <div>
      <div className="wrapper-slider">
        {/* <div className="notification">
          <div className="badge">
            <span className="button-slider">1</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span className="inactive">2</span>
          </div>
        </div> */}
        <Slider {...settings}>
          {dataImages &&
            dataImages.map((item, index) => {
              return (
                <div key={index} className="img-container">
                  <div
                    style={{
                      background: `linear-gradient(45deg, rgba(0,0,0,0.42), rgba(0,0,0,0.42)), url(${ApiUtils.validateImgUrl(
                        {
                          url: item?.images?.img?.display,
                        }
                      )})`,
                      backgroundSize: 'contain',
                      backgroundPosition: 'center',
                      backgroundBlendMode: 'color',
                      backgroundRepeat: 'no-repeat',
                      height: '90vh',
                    }}
                    alt="placeholder"
                    className="w-100"
                  />
                </div>
              );
            })}
        </Slider>
      </div>
      <div className="footer">
        <Row className="m-1">
          <Col>
            <button
              type="button"
              className="border-0 btn btn-outline-danger btn-sm w-100"
              onClick={onCancel}
            >
              Cancel
            </button>
          </Col>
          <Col>
            <button
              type="button"
              className="border-0 btn btn-danger btn-sm"
              onClick={handleNext}
            >
              Next
            </button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PreviewResult;
